<ng-container *ngIf="crumbs.length">
  <div class="crumbs">
    <div
      class="crumb mat-display-2"
      *ngFor="let crumb of crumbs; let last = last; trackBy: 'name' | trackBy"
    >
      <ng-container *ngIf="crumb.url; else noLink">
        <a [routerLink]="crumb.url">{{ crumb.name }}</a>
      </ng-container>

      <ng-template #noLink>
        <i>{{ crumb.name }}</i>
      </ng-template>

      <span *ngIf="!last">/</span>
    </div>
  </div>
</ng-container>
